export default function Mission() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E8F5E9] mb-6">
            <i className="ri-plant-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">私たちのミッション</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            地域資源を活かし、<br />
            持続可能な未来をつくる
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            廃校という地域の課題を、新しい産業と雇用を生み出すチャンスに変える。<br />
            環境に配慮した技術で、地域社会の持続的な発展に貢献します。
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-[#E8F5E9] to-white p-8 rounded-2xl border border-[#C8E6C9] hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="w-14 h-14 bg-[#2D7A3E] rounded-xl flex items-center justify-center mb-6">
              <i className="ri-recycle-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-[#1A2332] mb-4">循環型社会の実現</h3>
            <p className="text-gray-600 leading-relaxed">
              閉鎖循環型養殖システムにより、環境負荷を最小限に抑えた持続可能な食料生産を実現します。
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#E8F5E9] to-white p-8 rounded-2xl border border-[#C8E6C9] hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="w-14 h-14 bg-[#2D7A3E] rounded-xl flex items-center justify-center mb-6">
              <i className="ri-community-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-[#1A2332] mb-4">地域雇用の創出</h3>
            <p className="text-gray-600 leading-relaxed">
              廃校を活用した新しい産業拠点により、地域に安定した雇用と若い労働力を呼び込みます。
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#E8F5E9] to-white p-8 rounded-2xl border border-[#C8E6C9] hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="w-14 h-14 bg-[#2D7A3E] rounded-xl flex items-center justify-center mb-6">
              <i className="ri-flask-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-[#1A2332] mb-4">先進技術の活用</h3>
            <p className="text-gray-600 leading-relaxed">
              筑波大学との共同研究により、最先端の陸上養殖技術を地域産業として実装します。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}